module.exports = __webpack_public_path__ + "static/media/piyush-profile.72d00ac5.jpg";